/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRectangleVertical = createReactComponent("outline", "rectangle-vertical", "IconRectangleVertical", [["path", { "d": "M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }]]);

export { IconRectangleVertical as default };
//# sourceMappingURL=IconRectangleVertical.mjs.map
